"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AminoConverter = void 0;
const helpers_1 = require("../../../helpers");
exports.AminoConverter = {
    "/archway.rewards.v1.MsgSetContractMetadata": {
        aminoType: "/archway.rewards.v1.MsgSetContractMetadata",
        toAmino: ({ senderAddress, metadata }) => {
            return {
                sender_address: senderAddress,
                metadata: {
                    contract_address: metadata.contractAddress,
                    owner_address: metadata.ownerAddress,
                    rewards_address: metadata.rewardsAddress
                }
            };
        },
        fromAmino: ({ sender_address, metadata }) => {
            return {
                senderAddress: sender_address,
                metadata: {
                    contractAddress: metadata.contract_address,
                    ownerAddress: metadata.owner_address,
                    rewardsAddress: metadata.rewards_address
                }
            };
        }
    },
    "/archway.rewards.v1.MsgWithdrawRewards": {
        aminoType: "/archway.rewards.v1.MsgWithdrawRewards",
        toAmino: ({ rewardsAddress, recordsLimit, recordIds }) => {
            return {
                rewards_address: rewardsAddress,
                records_limit: {
                    limit: recordsLimit.limit.toString()
                },
                record_ids: {
                    ids: recordIds.ids.map(el0 => el0.toString())
                }
            };
        },
        fromAmino: ({ rewards_address, records_limit, record_ids }) => {
            return {
                rewardsAddress: rewards_address,
                recordsLimit: {
                    limit: helpers_1.Long.fromString(records_limit.limit)
                },
                recordIds: {
                    ids: record_ids.ids.map(el1 => helpers_1.Long.fromString(el1))
                }
            };
        }
    },
    "/archway.rewards.v1.MsgSetFlatFee": {
        aminoType: "/archway.rewards.v1.MsgSetFlatFee",
        toAmino: ({ senderAddress, contractAddress, flatFeeAmount }) => {
            return {
                sender_address: senderAddress,
                contract_address: contractAddress,
                flat_fee_amount: {
                    denom: flatFeeAmount.denom,
                    amount: helpers_1.Long.fromValue(flatFeeAmount.amount).toString()
                }
            };
        },
        fromAmino: ({ sender_address, contract_address, flat_fee_amount }) => {
            return {
                senderAddress: sender_address,
                contractAddress: contract_address,
                flatFeeAmount: {
                    denom: flat_fee_amount.denom,
                    amount: flat_fee_amount.amount
                }
            };
        }
    }
};
//# sourceMappingURL=tx.amino.js.map